import { useMemo, useState } from "react";
import { Search } from "lucide-react";
import { STEP_TYPES } from "@/lib/wf";

const dragData = (e, payload) => {
  e.dataTransfer.setData("application/mh-step", JSON.stringify(payload));
  e.dataTransfer.effectAllowed = "copy";
};

export const WorkflowPalette = ({ agents, deps, onPick }) => {
  const [q, setQ] = useState("");
  const shown = useMemo(() => agents.filter((a) => !q || a.name.toLowerCase().includes(q.toLowerCase())).slice(0, 60), [agents, q]);
  return (
    <aside className="w-full h-full flex flex-col min-h-0" data-testid="wf-palette">
      <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-muted-foreground px-1">Steps</div>
      <div className="grid grid-cols-1 gap-1.5 mt-2">
        {["approval", "condition", "delay"].map((t) => (
          <div key={t} draggable onDragStart={(e) => dragData(e, { type: t })} onClick={() => onPick?.({ type: t })} data-testid={`palette-${t}`}
            className="cursor-grab active:cursor-grabbing px-3 py-2 rounded-lg border border-white/[0.08] bg-white/[0.02] hover:border-white/25 transition-colors">
            <div className="text-sm flex items-center gap-2"><span className="w-2 h-2 rotate-45" style={{ background: STEP_TYPES[t].color }} />{STEP_TYPES[t].label}</div>
            <div className="text-[11px] text-muted-foreground mt-0.5">{STEP_TYPES[t].hint}</div>
          </div>
        ))}
      </div>
      <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-muted-foreground px-1 mt-5">Atlas agents</div>
      <div className="relative mt-2">
        <Search className="w-3.5 h-3.5 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Find an agent…" data-testid="palette-search"
          className="w-full h-9 pl-8 pr-3 rounded-lg bg-white/[0.03] border border-white/10 text-sm outline-none focus:border-white/30" />
      </div>
      <div className="mt-2 space-y-1 overflow-y-auto flex-1 min-h-0 pr-1">
        {shown.map((a) => (
          <div key={a.slug} draggable onDragStart={(e) => dragData(e, { type: "agent", slug: a.slug })} onClick={() => onPick?.({ type: "agent", slug: a.slug })}
            data-testid={`palette-agent-${a.slug}`} className="cursor-grab active:cursor-grabbing px-3 py-2 rounded-lg hover:bg-white/[0.05] transition-colors"
            style={{ borderLeft: `2px solid ${deps[a.department]?.hex || "#fff"}` }}>
            <div className="text-sm truncate">{a.name}</div>
            <div className="font-mono text-[10px] text-muted-foreground">{deps[a.department]?.name} · {a.stage}</div>
          </div>
        ))}
      </div>
    </aside>
  );
};
